import { useQuery } from '@tanstack/react-query';
import { useTramaClient } from '../context.js';
import type { TramaProduct } from 'trama-types';

export function useProduct(id: string | null) {
  const client = useTramaClient();

  return useQuery({
    queryKey: ['product', id],
    queryFn: () => client.request<TramaProduct>(`/api/v1/products/${id}`),
    enabled: Boolean(id),
  });
}
